import type { ReactNode } from 'react'

import {
  AccountLaneHeader,
  type LaneActions,
} from '@/modules/projects/components/Workbench/AccountLaneHeader'
import type { StatusFor } from '@/modules/projects/components/Workbench/coverage'
import { LaneFrame } from '@/modules/projects/components/Workbench/LaneFrame'
import type { MapLane } from '@/modules/projects/components/Workbench/map'
import type {
  Highlight,
  MapActions,
} from '@/modules/projects/components/Workbench/mapView'
import { YearRows } from './YearRows'

export interface LaneSectionProps {
  lane: MapLane
  choosing: boolean
  openStatementId: string | null
  highlight: Highlight
  statusFor: StatusFor
  actions: MapActions
  laneActions: LaneActions
  children?: ReactNode
}

export const LaneSection = ({
  lane,
  laneActions,
  children,
  ...shared
}: LaneSectionProps) => (
  <LaneFrame
    label={<AccountLaneHeader lane={lane} laneActions={laneActions} />}
    timeline={<YearRows lane={lane} {...shared} />}
    labelStays={lane.years.length > 1}
  >
    {children}
  </LaneFrame>
)
